export default "__VITE_ASSET__C2na5r4T__"